<template>
  <NumberMetric
    v-if="isNumber"
    :size="componentType === 'BIG_NUMBER' ? 'big' : 'small'"
    :value="metric.value"
    :prefix="metric.prefix"
    :suffix="metric.suffix"
    :label="metric.label"
    :is-earnings="isEarnings"
    :is-dollar-budget="isDollarBudget"
    :basis="basis"
  />
  <ProgressBarMetric
    v-else-if="componentType === 'PROGRESS_BAR'"
    :progress="metric.progress"
    :range-start-label="metric.rangeStartLabel"
    :range-end-label="metric.rangeEndLabel"
    :accessible-name="metric.label"
  />
  <StatusMetric
    v-else-if="componentType === 'STATUS'"
    :met="metric.met"
    :met-label="metric.metLabel"
    :not-met-label="metric.notMetLabel"
  />
</template>

<script>
import NumberMetric from "./NumberMetric.vue";
import ProgressBarMetric from "./ProgressBarMetric.vue";
import StatusMetric from "./StatusMetric.vue";

export default {
  name: "ProgramMetric",
  components: { NumberMetric, ProgressBarMetric, StatusMetric },
  props: {
    componentType: { type: String, required: true },
    /**
     * Already-resolved display values. Mapping a ProgramMetricColumn's attribute
     * bindings onto these belongs to the caller, since the Inform metric values
     * they point at are served by a BFF that does not exist yet (ADO 189165).
     */
    metric: { type: Object, default: () => ({}) },
    isEarnings: { type: Boolean, default: false },
    isDollarBudget: { type: Boolean, default: false },
    basis: { type: String, default: null },
  },
  computed: {
    isNumber() {
      return this.componentType === "BIG_NUMBER" || this.componentType === "SMALL_NUMBER";
    },
  },
};
</script>
